// hooks/useInvoices.ts
import { Offer } from "../types/offerForm";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { addItem, editItem, deleteItem, copyItem, clearItems } from "../features/offerSlice"

export function useOffers() {
  const offers = useSelector((state: RootState) => state.offers ); // Get invoices from Redux stat
  const dispatch = useDispatch();

  const addOffer = (offer: Offer) => {
    dispatch(addItem(offer));
  };

  const editOffer = (offer: Offer) => {
    dispatch(editItem (offer));
  };

  const removeOffer = (id: number) => {
    if(id){
      dispatch(deleteItem({id}));
    }    
  };

  const copyOffer = (id: number, offer: Offer) => {   
    dispatch(copyItem({id: id, data: offer as Offer}));
  }

  const clearOffers = () => {    
    dispatch(clearItems(offers));
  };

  return {
    offers,
    addOffer,
    editOffer,
    removeOffer,
    copyOffer,
    clearOffers
  };
}
